// types
import { type ModuleType as Ratings } from "./_definitions"
import { type State } from "../../types"

export const ratingsSelector = (state: State): Ratings => state.ratings
